import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import TutelaLogo from '../icons/TutelaLogo';

interface AuthLayoutProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
}

/** Dark centered card used by the auth pages (entrar / registar / confirmation). */
export default function AuthLayout({ title, subtitle, children, footer }: AuthLayoutProps) {
  return (
    <div className="min-h-[calc(100vh-4rem)] bg-ink-950 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center mb-8 text-center">
          <Link to="/" className="mb-4" aria-label="Início">
            <TutelaLogo className="w-12 h-12" variant="light" />
          </Link>
          <h1 className="font-display text-2xl font-bold text-mist">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-mist-muted max-w-sm">{subtitle}</p>}
        </div>
        <div className="bg-ink-800 border border-ink-700 rounded-2xl p-6 sm:p-8">{children}</div>
        {footer && <div className="mt-6 text-center text-sm text-mist-muted">{footer}</div>}
      </div>
    </div>
  );
}
